import { cn } from "cn";

interface DemoWrapperProps {
  caption?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  height?: number;
}

export function DemoWrapper({
  children,
  className,
  height,
  caption,
}: DemoWrapperProps) {
  return (
    <div className="my-8 flex w-full flex-col items-center">
      <div
        className={cn(
          "flex w-full flex-col items-center justify-center overflow-hidden rounded-xl bg-surface shadow-raised",
          className
        )}
        style={{ height }}
      >
        {children}
      </div>
      {caption && (
        <div className="mt-4 flex w-full items-center justify-center text-center">
          {caption}
        </div>
      )}
    </div>
  );
}
